export const _convert_marker_data_to_html = (properties) => {
    const table_content = Object.entries(properties)
        .reduce((accum, [key, value]) => {
            const row = `
                <tr>
                    <td>${key}</td>
                    <td>${value}</td>
                </tr>
            `;
            return `${accum}${row}`
        }, '')

    return `
        <table class="popup_table striped">
            ${table_content}
        </table>
    `;
}

export function set_feature_style(feature) {
    const  { 
        color_line, line_weight, fill_color,
        fill_opacity, class_name, dash_array 
    } = feature

    const style = {
        ...color_line && { color: color_line},
        ...line_weight && { weight: line_weight },
        ...fill_color && { fillColor: fill_color },
        ...isFinite(fill_opacity) && { fillOpacity: fill_opacity },
        ...class_name && { className: class_name },
        ...dash_array && { dashArray: dash_array },
    };

    return style;
}

export function set_layer_popup_descriptions(layer, feature, language='tw', className='whitespace_nowrap') {
    if (feature.properties) {
        if(feature.properties.description && language === 'tw') {
            layer.bindPopup(feature.properties.description, {className: className});
        } else if (feature.properties.description_en && language === 'en') {
            layer.bindPopup(feature.properties.description_en, {className: className});
        }
    }
}

export function assign_description(options) {
    this.popup_type = 'description_info'
    this.description_info = options
    clear_all_data.call(this)
}

function clear_all_data() {
    this.gis_popup_data = {};
    this.gis_popup_type = '';
}

export const _get_common_click_event_options = (options) => {
    const { 
        product: { 
            product_type, 
            product_sub_type, 
            pane_text 
        }, 
        feature 
    } = options

    return {
        product_type, 
        product_sub_type,
        pane_text,
        unique_geometry: feature.geometry.coordinates,
    }
}

export function set_click_event(map_taget, options) {
    const {
        feature,
        language='tw',
        popup_html,
        popup_data,
    } = options

    let html = popup_html
    let popup_object = popup_data

    if (language === 'tw') {
        html = html || feature.properties?.description
        popup_object = popup_object || feature.properties
    }

    if (language === 'en') {
        html = html || feature.properties?.description_en || feature.properties?.description
        popup_object = popup_object || feature.properties_en || feature.properties
    }

    map_taget.on('click', () => assign_description.call(this, 
        {
            ..._get_common_click_event_options(options),
            html,
            popup_object,
        }
    ))
}